import React, { ReactNode } from "react";
import classNames from "classnames";
import { IconComponentProps } from "../..";

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  leftIcon: React.FC<IconComponentProps>;
  rightIcon: React.FC<IconComponentProps>;
  label: string;
  prepend: string;
  append: string;
  valid: boolean;
  invalid: boolean;
  helpText: ReactNode;
}

/*
const defaultProps = {
  label: '',
  helpText: '' as string | React.ComponentType,
  type: 'text' as
    | 'text'
    | 'password'
    | 'button'
    | 'checkbox'
    | 'radio'
    | 'color'
    | 'date'
    | 'datetime'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'number'
    | 'password'
    | 'range',
  name: '',
  placeholder: '',
  leftIcon: '',
  rightIcon: '',
  inputProps: {} as React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  required: false,
  invalid: false,
  disabled: false,
};
*/

export const InputField: React.FunctionComponent<Partial<Props>> = ({
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  label,
  helpText,
  prepend,
  append,
  invalid,
  valid,
  ...inputProps
}) => {
  const inputClassName = classNames(
    "input-group",
    { "has-icon-prepend": LeftIcon },
    { "has-icon-append": RightIcon },
    { "is-required": inputProps.required }
  );
  return (
    <div className="form-group">
      {label && <label className="form-input-label">{label}</label>}
      <div className={inputClassName}>
        {prepend && (
          <div className="input-group-prepend">
            <span className="input-group-text">{prepend}</span>
          </div>
        )}
        <input className="form-control" {...inputProps} />
        {append && (
          <div className="input-group-append">
            <span className="input-group-text">{append}</span>
          </div>
        )}
        {LeftIcon && (
          <div className="input-group-icon-prepend">
            <span className="input-group-icon">
              <LeftIcon color="black" size="24px" />
            </span>
          </div>
        )}

        {RightIcon && (
          <div className="input-group-icon-append">
            <span className="input-group-icon">
              <RightIcon color="black" size="24px" />
            </span>
          </div>
        )}
      </div>
      {helpText &&
        (typeof helpText === "string" ? (
          <small
            className={classNames({
              "form-text text-muted": !valid && !invalid,
              "invalid-feedback": invalid,
              "valid-feedback": valid,
            })}
          >
            {helpText}
          </small>
        ) : (
          helpText
        ))}
    </div>
  );
};
